module.exports = __webpack_public_path__ + "static/media/bgImage2.044d7f84.jpeg";